import moment from "moment";

import { DateRangeParam, SearchQueryParam } from "@features/sales-v3/context";
import {
  SavedSearchMethod,
  SavedSearchOperator,
} from "@north-beam/nb-client-side";
import { type AdKey, level, slugify } from "@north-beam/nb-common";
import { overviewTransactionsAndCac } from "@pages/sales/saved-views/sales-views-templates/overview-transactions-and-cac";

export interface salePageUrlParams {
  adKey: AdKey;
  name: string;
  showV3SalesPage: boolean;
  displayUserId: string;
}

export const salesPageUrl = ({
  adKey,
  name,
  showV3SalesPage,
  displayUserId,
}: salePageUrlParams) => {
  const url = new URL(`${window.location.origin}`);
  const lvl = level(adKey);
  const startDate = "2019-01-01";
  const endDate = moment().add("day", -1).format("YYYY-MM-DD");

  if (showV3SalesPage) {
    url.searchParams.set("granularity", lvl);
    url.searchParams.set("activeTab", lvl);
    url.searchParams.set(
      "dateRange",
      DateRangeParam.encode({
        startDate,
        endDate,
        type: "fixed",
      }) as string,
    );
    url.searchParams.set("flyoutId", slugify(adKey));
    url.searchParams.set("savedViewId", "default");
    url.searchParams.set(
      "searchQuery",
      SearchQueryParam.encode({
        method: SavedSearchMethod.text,
        operator: SavedSearchOperator.is,
        query: name,
      }) as string,
    );
  } else {
    url.searchParams.set("granularity", lvl);
    url.searchParams.set("flyoutPath", slugify(adKey));
    url.searchParams.set("searchValue", name);
    url.searchParams.set(
      "dateRange",
      JSON.stringify({
        type: "fixed",
        startDate,
        endDate,
      }),
    );
    url.searchParams.set("savedView", overviewTransactionsAndCac.id);
  }

  url.pathname = `${displayUserId}/sales`;

  return url.toString();
};
